import { render, staticRenderFns } from "./order_info.vue?vue&type=template&id=3111b17b&scoped=true"
import script from "./order_info.vue?vue&type=script&lang=js"
export * from "./order_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3111b17b",
  null
  
)

export default component.exports